import { render, staticRenderFns } from "./indexRepairComplaint.vue?vue&type=template&id=168c371e&scoped=true"
import script from "./indexRepairComplaint.vue?vue&type=script&lang=js"
export * from "./indexRepairComplaint.vue?vue&type=script&lang=js"
import style0 from "./indexRepairComplaint.vue?vue&type=style&index=0&id=168c371e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168c371e",
  null
  
)

export default component.exports